import { NavLink, } from "react-router";
import { IoClose, IoExit, IoMenu } from "react-icons/io5";
import { sidebarRoutes } from "../sidebarRoutes/SidebarRoutes";
import { useAuth } from "../context/AuthContext";

function SideBar({ openMenu, setOpenMenu }) {
  const { user, logout } = useAuth()
  const userRole = user.role;
  const menuItems = sidebarRoutes[userRole] || [];

  return (
    <>
      <div className="px-4 py-6">
        <i
          onClick={() => setOpenMenu(!openMenu)}
          className="text-2xl text-white font-bold cursor-pointer"
        >
          {openMenu ? <IoClose /> : <IoMenu />}
        </i>

        <ul className="mt-3 space-y-1">
          {menuItems.map((item) => (
            <li key={item.path} className="relative group">
              <NavLink
                to={{
                  pathname: item.path,
                  search: item.search,
                }}
                className={({ isActive }) => `block rounded-sm hover:text-blue-950 hover:bg-[#0FCFFF] px-4 py-[7px] my-2 text-md font-medium ${isActive
                  ? "text-blue-950 bg-[#0FCFFF]"
                  : "text-white border border-[#0FCFFF]"
                  }`}
              >
                <span className="flex items-center text-xl gap-2">
                  {item.icon}
                  {openMenu && <span className="text-[15px] md:text-sm">{item.label}</span>}
                </span>
              </NavLink>
              {!openMenu && (
                <span className="absolute left-full ml-2 w-auto min-w-max p-2 rounded-md bg-gray-800 text-white text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ul>
      </div>
      <div className="sticky z-50 bg-black h-fit bottom-0 border-t border-#0FCFFF">
        <button
          to="#"
          onClick={logout}
          className="block rounded-lg px-4 py-2 m-4 font-medium hover:bg-red-500 hover:text-white text-red-300 border border-red-500"
        >
          <span className="flex items-center text-xl gap-2">
            <IoExit color="white" />
            {openMenu && <span className="text-sm">Logout</span>}
          </span>
        </button>
      </div>
    </>
  );
}

export default SideBar;
